import { render, staticRenderFns } from "./RegistrationContact.vue?vue&type=template&id=f9a7990a&scoped=true"
import script from "./RegistrationContact.vue?vue&type=script&lang=js"
export * from "./RegistrationContact.vue?vue&type=script&lang=js"
import style0 from "./RegistrationContact.vue?vue&type=style&index=0&id=f9a7990a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a7990a",
  null
  
)

export default component.exports